import { Row, Col } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/DataTable';
import { KpiCard } from '../../components/KpiCard';
import { useManagedDbStats } from './useManagedDbStats';

/**
 * Produkt-Statistik Managed-DBs — Betreiber-Sicht, nur lesend. KPI-Kacheln oben,
 * darunter die Aufschlüsselung nach Engine und Status.
 */
const fmt = new Intl.NumberFormat('de-DE');

export function NexusManagedDbStatsPage() {
  const stats = useManagedDbStats();
  const data = stats.data ?? {};
  const byEngine = data.byEngine ?? [];
  const byStatus = data.byStatus ?? [];

  return (
    <div>
      <PageHeader title="Managed-DBs" subtitle="Produkt-Statistik — verwaltete Datenbanken" />

      <Row className="g-3 mb-3">
        <Col xs="6" md="4" lg="3"><KpiCard label="Managed-DBs" value={fmt.format(data.databases ?? 0)} /></Col>
        <Col xs="6" md="4" lg="3"><KpiCard label="Tenants" value={fmt.format(data.tenants ?? 0)} /></Col>
      </Row>

      <Row className="g-3">
        <Col xs={12} lg={6}>
          <div className="text-muted small text-uppercase mb-2">Nach Engine</div>
          <DataTable
            loading={stats.isLoading}
            error={stats.error}
            empty={!stats.isLoading && byEngine.length === 0}
            emptyMessage="Keine Engine-Daten."
            onRetry={() => stats.refetch()}
          >
            <thead>
              <tr>
                <th>Engine</th>
                <th className="text-end">Datenbanken</th>
              </tr>
            </thead>
            <tbody>
              {byEngine.map((r) => (
                <tr key={r.engine}>
                  <td className="small">{r.engine}</td>
                  <td className="text-end small">{fmt.format(r.n ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>

        <Col xs={12} lg={6}>
          <div className="text-muted small text-uppercase mb-2">Nach Status</div>
          <DataTable
            loading={stats.isLoading}
            error={stats.error}
            empty={!stats.isLoading && byStatus.length === 0}
            emptyMessage="Keine Status-Daten."
            onRetry={() => stats.refetch()}
          >
            <thead>
              <tr>
                <th>Status</th>
                <th className="text-end">Datenbanken</th>
              </tr>
            </thead>
            <tbody>
              {byStatus.map((r) => (
                <tr key={r.status}>
                  <td className="small">{r.status}</td>
                  <td className="text-end small">{fmt.format(r.n ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>
      </Row>
    </div>
  );
}
